import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { NewsletterForm } from './NewsletterForm';

export const NewsletterSlider: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 px-6 bg-muted/30">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl font-semibold mb-3">
          {t('newsletter', 'title')}
        </h2>
        <p className="text-muted-foreground mb-10 max-w-lg mx-auto">
          {t('newsletter', 'subtitle')}
        </p>

        <div className="max-w-md mx-auto">
          <NewsletterForm variant="slider" />
        </div>

        <p className="text-muted-foreground text-sm mt-6">
          {t('newsletter', 'growingCommunity.description')}
        </p>
      </div>
    </section>
  );
};
